module.exports = __webpack_public_path__ + "static/media/notices.788449ee.jpg";